import { render, staticRenderFns } from "./CompletionTime.vue?vue&type=template&id=c489c3f6&scoped=true&"
import script from "./CompletionTime.vue?vue&type=script&lang=js&"
export * from "./CompletionTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c489c3f6",
  null
  
)

export default component.exports